import style from "./LibraryLabel.module.css";

export const LibraryLabel = ({label, icon}) => {
    return (
        <div className={style.label}>
            {icon}
            <span>{label}</span>
        </div>
    );
};